import {Component, CUSTOM_ELEMENTS_SCHEMA, Inject} from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Router, RouterModule} from '@angular/router';
import {UserService} from '../../../domain/user/service/user.service';
import {SessionStorageService} from '../../../_service/session-storage.service';
import {NativeService} from '../../../_service/native.service';
import {CommonModule} from "@angular/common";
import {FlexLayoutModule} from "@ngbracket/ngx-layout";
import {MatListModule} from "@angular/material/list";
import {MatIconModule} from "@angular/material/icon";
import {take} from "rxjs";

@Component({
  selector: 'app-mobile-footer-sheet',
  templateUrl: './mobile-footer-sheet.component.html',
  styleUrl: './mobile-footer-sheet.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatBottomSheetModule,
    MatListModule,
    MatIconModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MobileFooterSheetComponent {
  links: any[] = [];
  title = '';
  description = '';

  constructor(private readonly log: NGXLogger,
              @Inject(MAT_BOTTOM_SHEET_DATA) private readonly data: any,
              private readonly nativeService: NativeService,
              private readonly ref: MatBottomSheetRef,
              private readonly router: Router,
              private readonly userService: UserService,
              private readonly sessionStorage: SessionStorageService) {
    this.links = this.data.links;
    this.title = this.data.title;
    this.description = this.data.description;
  }

  close(): void {
    this.ref.dismiss();
  }

  clickLink(link: any) {
    if (link.logout) {
      this.userService.logout();
      this.sessionStorage.clear();
      this.nativeService.forgetMe();
    } else if (link.staticPage) {
      this.ref.dismiss(link.type);
      window.location.assign(link.path);
    } else {
      this.ref.afterDismissed().pipe(take(1)).subscribe(() => {
        this.router.navigate([link.path], {queryParams: link.queryParams})
          .then(() => {
            requestAnimationFrame(() => this.scrollToTop());
          });
      });
      this.ref.dismiss(link.type);
    }
  }

  private scrollToTop() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.scrollingElement?.scrollTo(0, 0);
  }
}
